import Modal, { ModalActions, ModalContent } from './modal';
export { default as AlertModal } from './alert';
export { ModalActions, ModalContent };
export default Modal;
